/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElm('.image_change_with_multiple').then((elm) => {
  const inputEle = document.querySelectorAll(".image_change_with_multiple");
  if(inputEle !== null){
    inputEle.forEach(el => el.addEventListener('click',function (e) {
         newSelectedValue = e.target.value;
         if(newSelectedValue){
           calculateSelectedAlt(el,newSelectedValue);
         }
         
      }))

    var firstElement = inputEle[0];
    firstElement.addEventListener('click',function (e) {
         newSelectedValue = e.target.value;
         addVariationNameToUrl(newSelectedValue);
      })
  
    calculateSelectedAlt(null,null);

    setVariationFromUrl(firstElement);
  }
});

function setVariationFromUrl(element) {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('v');
  if(myParam !== null){
    waitForElm('.hulkapps_swatch_option').then((elm) => {
      var options = element.getElementsByClassName('hulkapps_swatch_option');
      let i=0;
      for(; i<options.length; i++){
          if (options[i].ariaLabel == myParam + ' ') {
            options[i].click();
            break;
          }
      }
    })
  }
}


function addVariationNameToUrl(newSelectedValue) {
  var getURLStr = getURL('v', newSelectedValue);
  getURLStr = getURLStr.startsWith('&') ? getURLStr.slice(1) : getURLStr;
  var newURL = window.location.href.split('?')[0] + '?' + getURLStr;
  history.pushState({}, null, newURL);
}

function getURL(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);

    // kvp looks like ['key1=value1', 'key2=value2', ...]
    var kvp = document.location.search.substr(1).split('&');
    let i=0;

    for(; i<kvp.length; i++){
        if (kvp[i].startsWith(key + '=')) {
            let pair = kvp[i].split('=');
            pair[1] = value;
            kvp[i] = pair.join('=');
            break;
        }
    }

    if(i >= kvp.length){
        kvp[kvp.length] = [key,value].join('=');
    }

    // can return this or...
    let params = kvp.join('&');

    // reload page with new params
    return params;
}

function calculateSelectedAlt(changedElement,newSelectedValue) {
  var selectedValue = "";
  const inputEle = document.querySelectorAll(".image_change_with_multiple"); 
  inputEle.forEach(el => selectedValue = addSelectedValue(el,changedElement,newSelectedValue,selectedValue));
  filterThumbImages(selectedValue.slice(0, selectedValue.length - 1));
}

function addSelectedValue(el,changedElement,newSelectedValue,selectedValue) {
  if (el == changedElement)
    selectedValue += newSelectedValue + '_'
  else{
    var hidValue = el.querySelector(".hulk_swatch_hidden_prop"); 
    selectedValue += hidValue["value"] + '_'
  }
  return selectedValue;
}

function filterThumbImages(altValue){
  const productThumbs = document.querySelector(".product__thumbnail-list");
  const inputEle = productThumbs.querySelectorAll(".product__thumbnail-item");
  var modelFound = null;
  inputEle.forEach(el => modelFound = setThumbVisiblity(el,altValue, modelFound));

  const productMains = document.querySelector(".product__media-list");
  const mainEle = productMains.querySelectorAll(".product__media-item");
  mainEle.forEach(el => setMainVisiblity(el,altValue));

  productThumbs.style.display="block";

  document.querySelectorAll("[id$=-media-list]")[0].reload();
}

function setThumbVisiblity(el,altValue, modelFound){
   var image = el.querySelector("img");
   static_value = 'Static_' + altValue.split('_')[0]
   if(image["alt"] == altValue || image["alt"].endsWith(static_value) || image["alt"].endsWith('_3DModel') || image["alt"].endsWith('Static') ){
     el.classList.remove("hide");
   }
   else{
     el.classList.add("hide");
   }

   if(image["alt"].endsWith('_3DModel')){
     el.parentNode.prepend(el);
     return el;
   }

  if(image["alt"] == altValue){
    if(modelFound === null)
       el.parentNode.prepend(el);
    else{
      el.parentNode.prepend(el);
      el.parentNode.prepend(modelFound);
    }
   }

  return modelFound;
}

function setMainVisiblity(el,altValue){
 var image = el.querySelector("img");
 static_value = 'Static_' + altValue.split('_')[0]
 if(image != null){
   if(image["alt"] == altValue || image["alt"].endsWith(static_value) || image["alt"].endsWith("Static")){
     el.classList.remove("is-filtered");
   }
   else{
     el.classList.add("is-filtered");
   }

   if(image["alt"] == altValue){
     el.parentNode.prepend(el);
   }
 }

  var model = el.querySelector("model-media");
  if(model != null){
    el.classList.remove("is-filtered");
  }
  
}

window.addEventListener("load", function(){
    setupViewer();
});

async function setupViewer() {
  // Initialize the viewer
  const viewer = new ViewerApp({
    canvas: document.querySelector('canvas')
  });
  // Change this value to scale the configurator
  const rootScaleFactor = 2;
  viewer.scene.modelRoot.scale.set(rootScaleFactor, rootScaleFactor, rootScaleFactor);
  
  // Add all the plugins at once
  await addBasePlugins(viewer, { importPopup: false, enableDrop: false });
  let diamondPlugin = await viewer.getOrAddPlugin(DiamondPlugin);
  // await viewer.getOrAddPlugin(DebugPlugin)
  
  // This must be called after adding any plugin that changes the render pipeline.
  viewer.renderer.refreshPipeline();
  
  const ground = viewer.getPlugin(GroundPlugin);
  // this wont rebake the shadows whenever the model changes.
  ground.autoBakeShadows = false;
    
  const manager = viewer.getManager();

  // Disable the viewer untill the models, scenes and materials are loaded
  viewer.enabled = false;
  
  // Default layer definitions. Define all your layers here. Edit this structure to apply your own layer naming and materials 

  var metalColour = 'yellow'; 
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('v');
  if(myParam !== null){
    switch(myParam) {
      case 'Gold':
        metalColour = 'yellow';
        break;
      case 'Silver':
        metalColour = 'white';
        break;
      case 'Rose':
        metalColour = 'rose';
        break;
      default:
        metalColour = 'yellow';
    }
  }

  const defaultLayerConfig = 
  {
    'Metal 01' :  metalColour + '-gold.pmat',
    'Gem 01'   : 'diamond-stone.dmat',    
    'Gem 02'   : 'diamond-stone.dmat',
  }
  
  // used for storing materials for each diamond layer
  const layerMaterialMap = {};

  const baseURL = "//cdn.shopify.com/s/files/1/0327/4040/9479/files/";
    
  async function getOrCreateMaterial(layerName, matName) {
    let material = layerMaterialMap[matName];
    if(material !== undefined) {
      return material;
    } else {
      const matURL = baseURL + matName;
      if(matURL !== undefined) {
        material = await viewer.load(matURL);
        material.name = matName
        layerMaterialMap[matName] = material
        return material;
      } else {
        console.warn('Unable to find material for layer ', layerName)
      }
    }
  }
  
  async function applyMaterialToLayer(layerName, material) {

    const manager = viewer.getManager()
    
    const materials = manager.materials.findMaterialsByName(layerName)

    if(materials && materials.length > 0) {
        manager.materials.applyMaterial(material, layerName);
    } else {
        console.warn('Unable to find matching materials in Layers')
    }
  }

  async function applyLayerConfig(layerConfig) {
      for(let layerName in layerConfig) {
          const matName = layerConfig[layerName];
          const material = await getOrCreateMaterial(layerName, matName);
          applyMaterialToLayer(layerName, material);
      }
  }

  function cleanupScene() {
      viewer.scene.disposeSceneModels();
      //todo: dispose materials
      viewer.getManager()?.materials?.dispose();
  }
  
  // Loads a 3d model, with auto scaling, and centering. 
  async function loadModel(url) {
    const model = await viewer.load(url, { autoScale: false, autoCenter: true });

    setTimeout(()=>{
        if(this.onLoad) this.onLoad()
        document.getElementById('assetManagerLoadingScreen').style.display = "none";
    }, 200)
    
    return model;
  }
  
  const onClickColor = async (event) => {
    //event.stopImmediatePropagation();
    //el = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
    //calculateSelectedAlt(el,event.target.value);
    const layerName = event.target.getAttribute('aria-layer');
    const name = event.target.getAttribute('aria-name');
    if(layerName !== null){
      let layerConfig = {};
      if(name === 'rose gold') {
        layerConfig[layerName] = 'rose-gold.pmat';
      }
      else if(name === 'white gold') {
        layerConfig[layerName] = 'white-gold.pmat';
      }
      else if(name === 'yellow gold') {
        layerConfig[layerName] = 'yellow-gold.pmat';
      }
      else{
        const dmat_name = name + '-stone.dmat'
        layerConfig[layerName] = dmat_name;
      }
      
      applyLayerConfig(layerConfig)
    }
  };


  var option_groups = document.getElementsByClassName('hulkapps_option');
  let i=0;
  for(; i<option_groups.length; i++){
    var option_name = option_groups[i].getElementsByClassName('hulkapps_option_name')[0].innerText;
    if (option_name == 'Gold Color') {
      var options = option_groups[i].getElementsByClassName('hulkapps_swatch_option')
      let o=0;
      for(; o<options.length; o++){
        
          radio_option = options[o].getElementsByClassName('hulkapps_option_child')[0];
          radio_option.setAttribute('aria-layer', 'Metal 01');
          labelValue = options[o].getAttribute('aria-label').trim();
          if(labelValue === 'Gold')
          {
            radio_option.setAttribute('aria-name', 'yellow gold');
          }
          else if(labelValue === 'Silver')
          {
            radio_option.setAttribute('aria-name', 'white gold');
          }
          else if(labelValue === 'Rose')
          {
            radio_option.setAttribute('aria-name', 'rose gold');
          }
          radio_option.onclick = onClickColor;
        }
    }

    else if (option_name == 'Stone' | option_name == 'Side Stone') {
      var options = option_groups[i].getElementsByClassName('hulkapps_swatch_option')
      let o=0;
      for(; o<options.length; o++){
        
          radio_option = options[o].getElementsByClassName('hulkapps_option_child')[0];

          if(option_name == 'Stone'){
            radio_option.setAttribute('aria-layer', 'Gem 01');
          }
          else if(option_name == 'Side Stone'){
            radio_option.setAttribute('aria-layer', 'Gem 02');
          }
          
          
          labelValue = options[o].getAttribute('aria-label').trim();
          if(labelValue === 'Diamond')
          {
            radio_option.setAttribute('aria-name', 'diamond');
          }
          else if(labelValue === 'Citrine')
          {
            radio_option.setAttribute('aria-name', 'yellow');
          }
          else if(labelValue === 'Pink')
          {
            radio_option.setAttribute('aria-name', 'pink');
          }
          else if(labelValue === 'Aquamarine')
          {
            radio_option.setAttribute('aria-name', 'aqua');
          }
          else if(labelValue === 'Black')
          {
            radio_option.setAttribute('aria-name', 'black');
          }
          else if(labelValue === 'Emerald')
          {
            radio_option.setAttribute('aria-name', 'green');
          }
          else if(labelValue === 'Sapphire')
          {
            radio_option.setAttribute('aria-name', 'sapphire');
          }
          else if(labelValue === 'Ruby')
          {
            radio_option.setAttribute('aria-name', 'ruby');
          }
          else if(labelValue === 'Amethyst')
          {
            radio_option.setAttribute('aria-name', 'ametyst');
          }
          radio_option.onclick = onClickColor;
        }
    }
  }
  
  
  // Load 3d model
  model_url = document.querySelector('model-url').getAttribute('src');
  detailModel = await loadModel(model_url);
  
  
  // Apply default layers
  await applyLayerConfig(defaultLayerConfig);

  // Load scene settings
  await viewer.load(
    "https://cdn.shopify.com/s/files/1/0327/4040/9479/files/3d2_3.vjson?v=1738002866"
  );
  
  // Finally enable the viewer
  viewer.enabled = true;
  viewer.fitToView();
  
  // manually bake the shadows once.
  ground.bakeShadows(); // required only if autoBakeShadows is false
}